export default __webpack_public_path__ + "static/media/Canal_do_Boi.3819ad25.png";